import { Constants } from "@app/constants/constants";
import { FeatureFlags } from "@app/feature-flag";
import { selectDoesUserHaveAction } from "@app/shared/state/authentication/authentication.selectors";
import { selectIsFeatureFlagOn } from "@app/shared/state/feature-flag/feature-flag.selectors";
import { createSelector } from "@ngrx/store";

export const selectShouldHaveAccessToDiscontinuedProducts = createSelector(
  selectIsFeatureFlagOn(FeatureFlags.DiscontinuedProducts.key),
  selectDoesUserHaveAction(
    Constants.UserActions.DiscontinuedProductsSupplierView,
  ),
  selectDoesUserHaveAction(
    Constants.UserActions.DiscontinuedProductsSupplierAdmin,
  ),
  (isFeatureFlagOn, hasViewAction, hasAdminAction) =>
    isFeatureFlagOn && (hasViewAction || hasAdminAction),
);
